
<p-panelMenu *ngIf="app?.menuMode!='horizontal'" [model]="items" [multiple]="false" [style]="{'width':'auto','background-color':'transparent'}" tooltipEvent="focus">
</p-panelMenu>
<ul class="layout-menu" *ngIf="app?.menuMode=='horizontal'">
    <li app-menuitem *ngFor="let item of items; let i = index;" [item]="item" [index]="i" [root]="true"></li>
</ul>